import axios from 'axios';
import Cookies from 'js-cookie';
import store from 'store2';
import { notification } from 'antd';
import { Subject } from 'rxjs';
import ApiService from '@services/Api/ApiService';

import { loginRequest, msalConfig } from '../../MsalConfig/authConfig';

class AuthService {
    pendingRequests = 0;
    finishedRequests = 0;

    msalInstance = null;
    msalAccounts = null;

    interceptorInit = false;

    userInitialDone = false;
    userAccessInitial = new Subject();

    requestSending = false;
    interceprotLoaded = false;

    userData = null;

    constructor() {
        // this.initAxiosInterceptor();

        this.userLoggedIn = !!this.getMsalToken();
    }

    initService() {
        this.initAxiosInterceptor();
    }


    // MSAL Single Sign On
    setMsalData(instance, accounts) {
        this.msalInstance = instance;
        this.msalAccounts = accounts;
    }

    getMsalInstance() {
        return this.msalInstance;
    }

    getMsalAccounts() {
        return this.msalAccounts;
    }

    sendSilentTokenRequest() {
        const accounts = this.getMsalAccounts();
        if (!accounts || !accounts.length) return;

        const instance = this.getMsalInstance();

        return instance.acquireTokenSilent({
            scopes: [msalConfig.auth.clientId],
            account: accounts[0]
        });
    }

    msalLogoutUser() {
        const instance = this.getMsalInstance();
        const accounts = this.getMsalAccounts();

        instance.logoutRedirect({
            account: accounts[0],
            postLogoutRedirectUri: '/'
        });
    }

    msalLoginUserRedirect() {
        const instance = this.getMsalInstance();
        instance.loginRedirect(loginRequest);
    }

    setMsalToken(token) {
        Cookies.set('MsalAuthToken', token, { expires: 7 });
        this.setNewAccessToken(token);
    }

    setNewAccessToken(token) {
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        this.getUserInitialSettings();
    }

    getMsalToken() {
        return Cookies.get('MsalAuthToken');
    }

    isMsalUserLoggedIn() {
        return this.sendSilentTokenRequest();
    }

    isLoggedIn() {
        return this.msalAccounts && this.msalAccounts.length > 0;
    }
    // Enf of MSAL methods

    getUserInitialSettings() {
        const baseUrl = process.env.REACT_APP_API_SERVER;
        return axios.get(baseUrl + '/api/v1/get-self/');
    }

    setUserInitialSettings(data) {
        if (this.userInitialDone) return;

        store.set('CorlyticsSession', data);
        store.set('roles', data.roles);
        console.log("Welcome " + this.getUsername())
        console.log("Application Version " + data.version);

        this.userInitialDone = true;
        this.userAccessInitial.next(true);
        return data;
    }

    getUserRoles() {
        const session = store.get('CorlyticsSession');
        if (session && session.roles) return session.roles;
        return [];
    }

    initAxiosInterceptor() {
        if (this.interceprotLoaded) return;
        this.interceprotLoaded = true;

        const getAccessToken = () => {
            const accounts = this.getMsalAccounts();
            if (!accounts || !accounts.length) return Promise.reject();

            const instance = this.getMsalInstance();

            return instance.acquireTokenSilent({
                scopes: [msalConfig.auth.clientId],
                // scopes: protectedResources.apiHello.scopes,
                account: accounts[0]
            });
        }

        const domain = window.location.origin
            .replace('cw-staging.corlytics', 'rig-staging.corlytics')
            .replace('cw.corlytics', 'app.corlytics');

        // Request interceptor
        axios.interceptors.request.use(
            async (request) => {
                if (request.url.indexOf('http') !== 0) {
                    const reqDomain = domain.slice(-1) === '/' ? domain.slice(0, -1) : domain;
                    const req = request.url.indexOf('//') === 0 ? request.url.replace('//', '/') : request.url;
                    request.url = reqDomain + req;
                }

                request.headers['Pragma'] = 'no-cache';

                try {
                    const token = await getAccessToken();
                    if (token) request.headers['Authorization'] = 'Bearer ' + token.accessToken;

                    this.toggleSpinner(true); // Start spinner
                    this.pendingRequests++;
                    return request;
                }
                catch (error) {

                    if (this.isLoggedIn()) this.msalLogoutUser();

                }
            }
        );

        // Response interceptor
        axios.interceptors.response.use(response => {
            this.finishedRequests++;

            if (this.pendingRequests === this.finishedRequests) {
                this.toggleSpinner(false); // Stop spinner
                this.resetRequests();
            }
            return response;
        }, error => {
            this.finishedRequests++;
            if (this.pendingRequests === this.finishedRequests) {
                this.toggleSpinner(false); // Stop spinner
                this.resetRequests();
            }

            if (error && error.toString() === 'Cancel') return;

            if (!error || !error.response) {
                notification.error({
                    message: 'Request Error',
                    description: 'Error occurred while loading'
                });
                return Promise.reject(error);
            }

            if (error.response.status === 404 && error.response.data && error.response.data.message) {
                notification.error({
                    message: 'Request Error',
                    description: error.response.data.message
                });
                return Promise.reject(error);
            }

            if (error.response.status === 400 && error.response.data && error.response.data.message) {
                notification.error({
                    message: 'Request Error',
                    description: error.response.data.message
                });
                return Promise.reject(error);
            }

            if (error.response.status === 401 || error.response.data.message === '401 Unauthorized') {
                const msg = error.response.data && error.response.data.message ? error.response.data.message : 'Unauthorized';
                notification.error({
                    message: msg
                });

                setTimeout(() => {
                    this.msalLogoutUser();
                }, 3000);
            }
            return Promise.reject(error);
        });
    }

    getUsername() {
        const session = store.get('CorlyticsSession');
        if (!session || !session.user) return '';
        return session.user.username;
    }









    toggleSpinner(loading) {
        document.body.classList[loading ? 'add' : 'remove']('loading');
    }






    resetRequests() {
        this.pendingRequests = 0;
        this.finishedRequests = 0;
    }

    publicUrl() {
        const url = process.env.PUBLIC_URL === '/' ? '' : process.env.PUBLIC_URL;
        return window.location.origin + url;
    }

    logoutUser() {
        Cookies.remove('rigtoken');
        store.clearAll();
        window.location.href = this.publicUrl() + '/login';
        return null;
    }

    loginUser(username, password) {
        return ApiService.loginUser(username, password);
    }

    setLoggedUserDetails(data, url) {
        Cookies.set('rigtoken', data.auth_token, { expires: 1 });
        store.set('username', data.message.replace('Welcome ', ''));
        store.set('dateFmt', data.dateFmt);
        store.set('currency', data.currency);
        this.setUserRoles(data.roles);
        this.userLoggedIn = true;
        window.location.href = this.publicUrl() + (url ? url : '/');
    }

    setUserRoles(roles) {
        store.set('roles', roles);
    }

    isUserLoggedIn() {
        return this.userLoggedIn;
    }

    isAdmin() {
        const roles = this.getUserRoles();
        return roles.includes('ADMIN');
    }
}

export default new AuthService();